var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9777 68.6449C63.9527 68.6173 63.9265 68.5882 63.8991 68.5577C63.6188 68.2447 63.2162 67.7776 62.7318 67.1661C61.7629 65.9428 60.4687 64.1435 59.174 61.8467C56.5837 57.2514 54 50.6801 54 42.7519C54 34.8255 56.5826 28.4749 59.1688 24.1022C60.4618 21.9161 61.7541 20.227 62.7212 19.0865C63.2047 18.5163 63.6065 18.0837 63.886 17.7949C63.9182 17.7616 63.9488 17.7303 63.9777 17.7008C64.0069 17.7305 64.0379 17.7621 64.0705 17.7957C64.3513 18.0845 64.7549 18.5172 65.2405 19.0873C66.2119 20.2279 67.5099 21.9169 68.8086 24.103C71.4062 28.4757 74 34.826 74 42.7519C74 50.6796 71.4051 57.2506 68.8033 61.8459C67.503 64.1427 66.203 65.942 65.2298 67.1653C64.7434 67.7768 64.3389 68.2439 64.0573 68.5568C64.0296 68.5877 64.003 68.617 63.9777 68.6449Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68.5V100.004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 111C66.7614 111 69 108.761 69 106C69 103.239 66.7614 101 64 101C61.2386 101 59 103.239 59 106C59 108.761 61.2386 111 64 111Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9606 72.5362C57.8778 72.2333 57.7516 71.8039 57.5729 71.2737C57.1976 70.1596 56.5915 68.6026 55.6708 66.8409C53.8286 63.3157 50.7356 58.9861 45.7264 55.7331C40.7186 52.481 35.6464 51.5067 31.8212 51.3465C29.9089 51.2665 28.3112 51.39 27.1944 51.533C26.6518 51.6025 26.2232 51.6765 25.9278 51.7337C25.9951 52.0278 26.1012 52.4509 26.2578 52.9768C26.5797 54.058 27.1143 55.5713 27.9629 57.2893C29.6604 60.7259 32.6086 64.9702 37.616 68.222C42.6247 71.4747 47.8424 72.5322 51.8168 72.774C53.803 72.8949 55.4742 72.8117 56.6465 72.6988C57.2049 72.645 57.6497 72.5845 57.9606 72.5362Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5703 73.93V87.6186L52.6021 92.6173",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 100C51.7091 100 53.5 98.2091 53.5 96C53.5 93.7909 51.7091 92 49.5 92C47.2909 92 45.5 93.7909 45.5 96C45.5 98.2091 47.2909 100 49.5 100Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0398 72.5362C70.1227 72.2333 70.2489 71.8039 70.4275 71.2737C70.8029 70.1596 71.409 68.6026 72.3297 66.8409C74.1718 63.3157 77.2649 58.9861 82.2741 55.7331C87.2819 52.481 92.3541 51.5067 96.1793 51.3465C98.0916 51.2665 99.6892 51.39 100.806 51.533C101.349 51.6025 101.777 51.6765 102.073 51.7337C102.005 52.0278 101.899 52.4509 101.743 52.9768C101.421 54.058 100.886 55.5713 100.038 57.2893C98.3401 60.7259 95.3919 64.9702 90.3845 68.222C85.3758 71.4747 80.158 72.5322 76.1837 72.774C74.1975 72.8949 72.5263 72.8117 71.354 72.6988C70.7955 72.645 70.3508 72.5845 70.0398 72.5362Z",
    fill: "white",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4302 73.93V87.6186L75.3984 92.6173",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 100C76.2909 100 74.5 98.2091 74.5 96C74.5 93.7909 76.2909 92 78.5 92C80.7091 92 82.5 93.7909 82.5 96C82.5 98.2091 80.7091 100 78.5 100Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.91188d2e24759e7827b5f12f9731040e.svg";
export { ForwardRef as ReactComponent };